<template>
  <div class="customers data--cards">
    <div class="page__header">
        <div class="page__title">
          {{ $t(`pageTitles.${"customers"}`) }} 
        </div>
      <div class="page__right">
        <div class="selected-filters" v-if="selectedTeamIds.length > 0 || Object.keys(searchCustomerForms).length > 0">
          <div v-for="teamId in selectedTeamIds" :key="`team${teamId}`" class="selected-filters__filter">
            <span>Team: {{ getTeamDisplayName(teamId) }}</span>
            <div class="selected-filters__remove" @click="removeTeam(teamId)"></div>
          </div>

          <div class="selected-filters__filter" v-if="startDateFrom || startDateTo">
            <span>{{ $t(`searchCustomerFields.${"policyStartDate"}`) }}: {{ formatDate(startDateFrom) || '...' }} - {{
              formatDate(startDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearStartDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-if="endDateFrom || endDateTo">
            <span>{{ $t(`searchCustomerFields.${"policyEndDate"}`) }}: {{ formatDate(endDateFrom) || '...' }} - {{
              formatDate(endDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearEndDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-if="submitDateFrom || submitDateTo">
            <span>{{ $t(`searchCustomerFields.${"policySubmitDate"}`) }}: {{ formatDate(submitDateFrom) || '...' }} - {{
              formatDate(submitDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearSubmitDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-if="birthdayFrom || birthdayTo">
            <span>{{ $t('searchCustomerFields.birthday') }}: {{ formatDate(birthdayFrom) || '...' }} - {{ formatDate(birthdayTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearBirthday()"></div>
          </div>

          <div class="selected-filters__filter" v-if="zipFrom || zipTo">
            <span>{{ $t('searchCustomerFields.zip') }}: {{ formatRange(zipFrom, zipTo) }}</span>
            <div class="selected-filters__remove" @click="clearZip()"></div>
          </div>

          <div class="selected-filters__filter" v-if="pendencyNr">
            <span>{{ $t(`pendenciesTable.${"pendencyNr"}`) }}: {{ pendencyNr }}</span>
            <div class="selected-filters__remove" @click="clearPendencyNr()"></div>
          </div>

          <div class="selected-filters__filter" v-for="agentId in selectedAgents" :key="`agent${agentId}`">
            <span>Agent: 
              {{
                (searchCustomerForms.agents && searchCustomerForms.agents.find(a => a.id == agentId))
                  ? searchCustomerForms.agents.find(a => a.id == agentId).first_name + ' ' +
                  searchCustomerForms.agents.find(a => a.id == agentId).last_name
                  : 'Agent ' + agentId
              }}
            </span>
            <div class="selected-filters__remove" @click="removeAgent(agentId)"></div>
          </div>

          <div class="selected-filters__filter" v-if="hasTerminations">
            <span>
              Kündigungen:
              <span v-if="hasTerminations == 'true'">ja</span>
              <span v-else-if="hasTerminations == 'false'">nien</span>
            </span>

            <div class="selected-filters__remove" @click="clearTermination()"></div>
          </div>

          <div class="selected-filters__filter" v-if="paymentStatus">
            <span>
              Payment: {{ paymentStatus }}
            </span>

            <div class="selected-filters__remove" @click="clearPayment()"></div>
          </div> 

          <div class="selected-filters__filter" v-for="typeId in selectedCompanyTypes" :key="`type${typeId}`">
            <span>Company Type: 
              {{
                (searchCustomerForms.companyTypes && searchCustomerForms.companyTypes.find(item => item.id == typeId))
                  ? searchCustomerForms.companyTypes.find(item => item.id == typeId).type
                  : '...'
              }}
            </span>
            <div class="selected-filters__remove" @click="removeCompanyType(typeId)"></div>
          </div>

          <div class="selected-filters__filter" v-for="companyId in selectedCompanies" :key="`company${companyId}`">
            Company: 
            {{
              (searchCustomerForms.companies && searchCustomerForms.companies.find(item => item.id === companyId))
                ? searchCustomerForms.companies.find(item => item.id === companyId).name
                : '...'
            }}
            <div class="selected-filters__remove" @click="removeCompany(companyId)"></div>
          </div>
          <div class="selected-filters__filter" v-for="categoryId in selectedBranchCategories"
            :key="`category${categoryId}`"> 
            Branch Category: 
            <span>{{
              (searchCustomerForms.branchCategories && searchCustomerForms.branchCategories.find(item => item.id ==
                categoryId))
                ? searchCustomerForms.branchCategories.find(item => item.id == categoryId).name
                : '...'
              }}</span>
            <div class="selected-filters__remove" @click="removeBranchCategory(categoryId)"></div>
          </div>
          <div class="selected-filters__filter" v-for="statusId in selectedPolicyStatuses" :key="`status${statusId}`">
            Policy Status:
            <span>{{
              (searchCustomerForms.policyStatuses && searchCustomerForms.policyStatuses.find(item => item.id ==
                statusId))
                ? searchCustomerForms.policyStatuses.find(item => item.id == statusId)[`name`]
              : '...'
              }}</span>
            <div class="selected-filters__remove" @click="removePolicyStatus(statusId)"></div>
          </div>
        </div>
        <form class="search search--filter" @submit.prevent="searchCustomers()">
          <div class="search__wrapper">
            <input class="search__search" ref="search" :class="{ 'search__search--active': searchKeywords }" type="text"
              v-model="searchKeywords" />
            <div class="search__icon"></div>
            <div class="selected-filters__filter search__placeholder" v-if="searchPlaceholder">
              <div class="search__placeholder-content">
                {{ searchPlaceholder }}
                <div class="selected-filters__remove" @click="removeSearch()"></div>
              </div>
            </div>
            <div class="search__splitter"></div>
          </div>
          <div class="search__filter" ref="filterToggler" @click="showSearchFilter = !showSearchFilter"></div>
          <SearchFilter v-if="showSearchFilter" :filterToggler="$refs.filterToggler" :searchType="'customer'"
            :toggleSearchFilter="(state) => {
              showSearchFilter = state;
            }
              " />
        </form>

        <button type="button" class="button button--default" @click="showAddCustomerModal()"
          v-if="canCreateCustomer">
          {{ $t(`dashboard.statistics.${"addCustomerBtn"}`) }}
        </button>
      </div>
    </div>

    <div class="data_content">
      <NoData v-if="!canAccessCustomers" type="no-permission" />
      <Loading v-else-if="customersLoading" />
      <NoData v-else-if="customerCollectionError?.status === 403" type="no-permission" />
      <CustomersTable v-else :customers="customersPerPage.data || []" />
    </div>
    <Pagination v-if="canAccessCustomers && !customersLoading && customersPerPage.data && customersPerPage.data.length > 0"  :limit="3" :data="customersPerPage" @pagination-change-page="getResults"></Pagination>
  </div>
</template>


<script setup>
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import CustomersTable from "@/components/CustomersTable";
import Loading from "@/partials/Loading";
import SearchFilter from "@/partials/SearchFilter";
import NoData from "@/partials/NoData";

const store = useStore();
const route = useRoute();
const router = useRouter();

// Template refs
const search = ref(null);
const filterToggler = ref(null);

// Data
const searchPlaceholder = ref("");
const searchKeywords = ref("");
const showSearchFilter = ref(false);
const selectedTeamIds = ref([]);
const selectedTeamId = computed(() => selectedTeamIds.value.length > 0 ? selectedTeamIds.value[0] : null);
const selectedAgents = ref([]);
const selectedCompanyTypes = ref([]);
const selectedCompanies = ref([]);
const selectedBranchCategories = ref([]);
const selectedPolicyStatuses = ref([]);
const hasTerminations = ref("");
const paymentStatus = ref("");
const startDateFrom = ref("");
const startDateTo = ref("");
const endDateFrom = ref("");
const endDateTo = ref("");
const submitDateFrom = ref("");
const submitDateTo = ref("");
const birthdayFrom = ref("");
const birthdayTo = ref("");
const zipFrom = ref("");
const zipTo = ref("");
const pendencyNr = ref("");
const isInitialized = ref(false);

// Computed
const customersPerPage = computed(() => store.getters.customersPerPage);
const customersLoading = computed(() => store.getters.customersLoading);
const searchCustomerForms = computed(() => store.getters.searchCustomerForms);
 

const customerCollectionError = computed(() => store.getters.customerCollectionError);
 

// Page-level access check - user must have access to customers
const canAccessCustomers = computed(() => {
  const teamIds = store.getters.authorizedTeamIds("customer_access");
  const hasAccess = teamIds === null || teamIds.length > 0;
  
  if (!hasAccess) {
    return;
  }  
  
  return hasAccess;
});

const canCreateCustomer = computed(() => {
  if (selectedTeamId.value !== null) {
    return store.getters.hasTeamPermission("customer_create", selectedTeamId.value);
  }
  const teamIds = store.getters.authorizedTeamIds("customer_create");
  return teamIds === null || teamIds.length > 0;
});

// Methods
const formatDate = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);

  return `${day}/${month}/${year}`;
};

const formatRange = (from, to) => {
  if (!from && !to) return '';
  if (from && !to) return `${from} - ...`;
  if (!from && to) return `... - ${to}`;
  return `${from} - ${to}`;
};

const getTeamDisplayName = (teamId) => {
  const resolvedTeamId = Number(teamId);
  if (!Number.isInteger(resolvedTeamId) || resolvedTeamId <= 0) {
    return 'All authorized teams';
  }

  const teamNameFromMembership = store.getters.membershipFor(resolvedTeamId)?.team?.name;
  if (teamNameFromMembership) return teamNameFromMembership;

  const teamNameFromList = Array.isArray(store.getters.teams)
    ? store.getters.teams.find((team) => Number(team?.id) === resolvedTeamId)?.name
    : null;
  if (teamNameFromList) return teamNameFromList;

  const userTeamName = Array.isArray(store.getters.loggedUser?.teams)
    ? store.getters.loggedUser.teams.find((team) => Number(team?.id) === resolvedTeamId)?.name
    : null;
  if (userTeamName) return userTeamName;

  const currentTeamId = Number(store.getters.currentTeamId);
  if (Number.isInteger(currentTeamId) && currentTeamId > 0 && currentTeamId === resolvedTeamId) {
    return store.getters.membershipFor(currentTeamId)?.team?.name || `Team ${resolvedTeamId}`;
  }

  return `Team ${resolvedTeamId}`;
};

const loadFiltersFromQuery = (q) => {
  searchKeywords.value = q.search || "";
  zipFrom.value = q.zip_from || "";
  zipTo.value = q.zip_to || "";
  pendencyNr.value = q.pendency_number || "";

  const normalizedTeamIds = Array.isArray(q.teams)
    ? q.teams
    : typeof q.teams === 'string' && q.teams.length
      ? q.teams.split(',')
      : [];

  selectedTeamIds.value = normalizedTeamIds
    .flatMap((teamId) => String(teamId).split(','))
    .map((teamId) => Number(teamId))
    .filter((teamId) => Number.isInteger(teamId) && teamId > 0);

  if (q.agents) {
    selectedAgents.value = typeof q.agents === 'string' ? q.agents.split(",") : q.agents;
  } else {
    selectedAgents.value = [];
  }

  selectedCompanyTypes.value = q.companyTypes
    ? (typeof q.companyTypes === 'string' ? q.companyTypes.split(",") : q.companyTypes)
    : [];

  selectedCompanies.value = q.companies
    ? (typeof q.companies === 'string' ? q.companies.split(",") : q.companies)
    : [];

  selectedBranchCategories.value = q.branchCategories
    ? (typeof q.branchCategories === 'string' ? q.branchCategories.split(",") : q.branchCategories)
    : [];

  selectedPolicyStatuses.value = q.policyStatuses
    ? (typeof q.policyStatuses === 'string' ? q.policyStatuses.split(",") : q.policyStatuses)
    : [];

  birthdayFrom.value = q.birthday_from || q.birthdayFrom || q.birthday || "";
  birthdayTo.value = q.birthday_to || q.birthdayTo || q.birthday || "";
  hasTerminations.value = q.has_terminations || undefined;
  startDateFrom.value = q.startDateFrom || "";
  startDateTo.value = q.startDateTo || "";
  endDateFrom.value = q.endDateFrom || "";
  endDateTo.value = q.endDateTo || "";
  submitDateFrom.value = q.submitDateFrom || "";
  submitDateTo.value = q.submitDateTo || "";
  paymentStatus.value = q.payment_status || "";
};

const searchCustomers = async () => {
  store.commit("setCustomersLoading", true);

  const page = Number(route.query.page) || 1;

  await store.dispatch("searchCustomers", {
    search: searchKeywords.value,
    agents: selectedAgents.value,
    companyTypes: selectedCompanyTypes.value,
    companies: selectedCompanies.value,
    branchCategories: selectedBranchCategories.value,
    policyStatuses: selectedPolicyStatuses.value,

    has_terminations: hasTerminations.value,
    payment_status: paymentStatus.value,

    startDateFrom: startDateFrom.value,
    startDateTo: startDateTo.value,
    endDateFrom: endDateFrom.value,
    endDateTo: endDateTo.value,
    submitDateFrom: submitDateFrom.value,
    submitDateTo: submitDateTo.value,
    zip_from: zipFrom.value,
    zip_to: zipTo.value,
    birthday_from: birthdayFrom.value,
    birthday_to: birthdayTo.value,
    pendency_number: pendencyNr.value,
    teamId: selectedTeamIds.value.length > 0 ? selectedTeamIds.value : null,
    page,
  });

};

const updateQuery = () => {
  router.replace({
    query: {
      page: 1,
      search: searchKeywords.value || undefined,
      teams: selectedTeamIds.value.length > 0 ? selectedTeamIds.value : undefined,
      agents: selectedAgents.value.length ? selectedAgents.value.join(",") : undefined,
      companyTypes: selectedCompanyTypes.value.length ? selectedCompanyTypes.value.join(",") : undefined,
      companies: selectedCompanies.value.length ? selectedCompanies.value.join(",") : undefined,
      branchCategories: selectedBranchCategories.value.length ? selectedBranchCategories.value.join(",") : undefined,
      policyStatuses: selectedPolicyStatuses.value.length ? selectedPolicyStatuses.value.join(",") : undefined,
      has_terminations: hasTerminations.value || undefined,
      payment_status: paymentStatus.value || undefined,
      startDateFrom: startDateFrom.value || undefined,
      startDateTo: startDateTo.value || undefined,
      endDateFrom: endDateFrom.value || undefined,
      endDateTo: endDateTo.value || undefined,
      submitDateFrom: submitDateFrom.value || undefined,
      submitDateTo: submitDateTo.value || undefined,
      birthday_from: birthdayFrom.value || undefined,
      birthday_to: birthdayTo.value || undefined,
      pendency_number: pendencyNr.value || undefined,
      zip_from: zipFrom.value || undefined,
      zip_to: zipTo.value || undefined,
    },
  }).catch(() => { });
};

const getResults = (paginationPage) => {
  if (Number(route.query.page) === Number(paginationPage)) return;

  router.replace({
    query: { ...route.query, page: paginationPage },
  }).catch(() => { });
};

const clearStartDateRange = () => {
  startDateFrom.value = "";
  startDateTo.value = "";
  updateQuery();
};

const clearEndDateRange = () => {
  endDateFrom.value = "";
  endDateTo.value = "";
  updateQuery();
};

const clearSubmitDateRange = () => {
  submitDateFrom.value = "";
  submitDateTo.value = "";
  updateQuery();
};

const clearBirthday = () => {
  birthdayFrom.value = "";
  birthdayTo.value = "";
  updateQuery();
};

const clearPendencyNr = () => {
  pendencyNr.value = "";
  updateQuery();
};


const clearZip = () => {
  zipFrom.value = "";
  zipTo.value = "";
  updateQuery();
};

const removeTeam = (teamId) => {
  selectedTeamIds.value = selectedTeamIds.value.filter(id => id !== teamId);
  if (selectedTeamIds.value.length === 0) {
    clearAllDependentFilters();
  }
  updateQuery();
};

const clearAllDependentFilters = () => {
  selectedAgents.value = [];
  selectedCompanyTypes.value = [];
  selectedCompanies.value = [];
  selectedBranchCategories.value = [];
  selectedPolicyStatuses.value = [];

  hasTerminations.value = "";
  paymentStatus.value = "";
  birthdayFrom.value = "";
  birthdayTo.value = "";
  pendencyNr.value = "";
  zipFrom.value = "";
  zipTo.value = "";
  startDateFrom.value = "";
  startDateTo.value = "";
  endDateFrom.value = "";
  endDateTo.value = "";
  submitDateFrom.value = "";
  submitDateTo.value = "";

  store.commit("setSearchCustomerForms", {});
};

const removeAgent = (id) => {
  selectedAgents.value = selectedAgents.value.filter((x) => x !== id);
  updateQuery();
};

const removeCompanyType = (id) => {
  selectedCompanyTypes.value = selectedCompanyTypes.value.filter(
    (x) => x !== id
  );
  updateQuery();
};

const removeCompany = (id) => {
  selectedCompanies.value = selectedCompanies.value.filter((x) => x !== id);
  updateQuery();
};

const removeBranchCategory = (id) => {
  selectedBranchCategories.value = selectedBranchCategories.value.filter(
    (x) => x !== id
  );
  updateQuery();
};

const removePolicyStatus = (id) => {
  selectedPolicyStatuses.value = selectedPolicyStatuses.value.filter(
    (x) => x !== id
  );
  updateQuery();
};

const clearTermination = () => {
  hasTerminations.value = "";
  updateQuery();
};

const clearPayment = () => {
  paymentStatus.value = "";
  updateQuery();
};

const removeSearch = () => {
  searchKeywords.value = "";
  searchPlaceholder.value = "";
  updateQuery();
};

const showAddCustomerModal = () => {
  if (!canCreateCustomer.value) { 
    return;
  }
 
  store.commit("setShowAddCustomerModal", true);
  store.commit("setIsAddingCustomer", true);
};

// Watch
watch(
  () => route.query,
  async (query, previousQuery) => {
    if (!isInitialized.value) return;

    if (!query.page) {
      router.replace({ query: { ...query, page: 1 } });
      return;
    }
    loadFiltersFromQuery(query);
    if (query.teams !== previousQuery?.teams) {
      if (selectedTeamIds.value.length > 0) {
        await store.dispatch("getSearchCustomerForms", selectedTeamIds.value);
      } else {
        store.commit("setSearchCustomerForms", {});
      }
    }
    await searchCustomers();
  },
  { deep: true }
);

// Created logic
(async () => {
  // Log page initialization attempt
  if (!canAccessCustomers.value) {
    return;
  }  

  try {
    let teamIds = [];
    if (Array.isArray(route.query.teams)) {
      teamIds = route.query.teams.map(t => Number(t)).filter(t => Number.isInteger(t) && t > 0);
    } else if (typeof route.query.teams === 'string' && route.query.teams.length) {
      teamIds = [Number(route.query.teams)].filter(t => Number.isInteger(t) && t > 0);
    }
    
    if (teamIds.length > 0) {
      await store.dispatch("getSearchCustomerForms", teamIds);
    }
  } catch (error) {
    // Error already handled by store action or silently fail for initialization
  }

  // Handle initial load
  const query = route.query;
  if (!query.page) {
    await router.replace({ query: { ...query, page: 1 } });
    // After router replace, load filters and search with the updated query
    loadFiltersFromQuery(route.query);
    await searchCustomers();
  } else {
    loadFiltersFromQuery(query);
    await searchCustomers();
  }

  isInitialized.value = true;
})();
</script>

<style scoped lang="scss">
.customers {
  height: 100%;

  &__content {
    margin-bottom: 20px;
    height: calc(100% - 48px - 15px - 16px - 20px);
  }
}
 
</style>
